import * as React from "react";
import { CardBalanceState } from "@payment-client/reducers/Card";

export type CardBalanceContextValue = CardBalanceState;

export const CardBalanceContext = React.createContext<CardBalanceContextValue>({});

if (__DEV__) {
    CardBalanceContext.displayName = "CardBalanceContext";
}
